<template>
  <div
    id="settingSupportBottom"
    class="mainCard"
  >
    <div class="title">
      Support
    </div>
    <div class="desc">
      Need a hand? Feel free to drop us a message at support@globalcoachgroup.com
      or search our comprehensive Knowledge base.
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportBottom',
};
</script>

<style lang="scss" scoped>
  #settingSupportBottom {
    padding-top: 18px;
    color: var(--themeFontColor);

    .title {
      font-weight: bold;
      font-size: 16px;
      padding-bottom: 10px;
    }
  }
</style>
